// Copyright Materialize, Inc. and contributors. All rights reserved.
//
// Use of this software is governed by the Business Source License
// included in the LICENSE file.
//
// As of the Change Date specified in that file, in accordance with
// the Business Source License, use of this software will be governed
// by the Apache License, Version 2.0.

/**
 * Materialize chat link, redirects to the community Slack. Used both as a
 * "contact support" and a "join our Slack" call to action.
 */
export const SUPPORT_CHAT_URL = "https://materialize.com/s/chat";

/** Materialize support page, listing every support channel. */
export const SUPPORT_URL = "https://materialize.com/support/";
